<template>
  <div id="app">
    <section v-if="checkStatusError()">Error</section>
    <section v-else>
      <LoadingScreen :checkStatusLoaded="checkStatusLoaded()"
      :spaPrerenderTrigger="spaPrerenderTrigger()"/>
      <router-view name="header"/>
      <router-view name="content"/>
      <router-view name="footer"/>
    </section>

    <!-- Service Worker update pop-up -->
    <template v-if="updateExists">
      <a @click="refreshApp()" class="sw-update-bg">
      </a>
      <div @click="refreshApp()" class="sw-update">
        An update is available, click anywhere to continue.
      </div>
    </template>

  </div>
</template>

<script>

// Mixins
import updateSW from '@/mixins/updateSW';

// Components
import LoadingScreen from '@/components/ui-components/LoadingScreen.vue';

export default {
  created() {
    this.$store.dispatch('getApi');
  },
  head: {
    meta: [
      {
        name: 'application-name',
        content: 'University of Illinois at Chicago',
      },
      {
        name: 'description',
        content: 'Located in the heart of one of the world’s great cities, the University of Illinois at Chicago is a vital part of the educational, technological and cultural fabric of the region. As Chicago’s only public research university with more than 33,000 students, 16 colleges, a hospital and a health sciences system, UIC provides students access to excellence and opportunity.',
        id: 'desc',
      },
    ],
    script: [
      {
        type: 'text/javascript',
        src: '//onetrust.techservices.illinois.edu/scripttemplates/otSDKStub.js',
        charset: 'UTF-8',
        'data-domain-script': 'c2f2262d-b694-4eba-8f4b-142c102b685a',
        head: true,
        async: true,
      },
      {
        type: 'text/javascript',
        head: true,
        inner: 'function OptanonWrapper() { }',
      },
      {
        type: 'text/javascript',
        src: '//www.uic.edu/apps/web-alert/alert.js',
        body: true,
      },
    ],
    style: [
      { type: 'text/css', inner: '.optanon-show-settings-button.optanon-toggle-display { width: 100% !important; } .cookie-banner { flex: 1 0 100%; margin-top: 1rem; margin-bottom: 1rem;} .optanon-show-settings-popup-wrapper { display: flex !important; justify-content: center !important; }', undo: false },
    ],
  },
  mixins: [updateSW],
  components: {
    LoadingScreen,
  },
  methods: {
    checkStatusError() {
      return this.$store.state.errored;
    },
    checkStatusLoaded() {
      return (this.$store.state.connectedApi === true) && (this.$store.state.loadedApi === this.$store.state.apiCount);
    },
    spaPrerenderTrigger() {
      // for app builds, to let spa-prerenderer know the page is fully loaded
      if (process.env.NODE_ENV === 'production') {
        setTimeout(() => {
          document.dispatchEvent(new Event('prerender-page-loaded'));
        }, 4000); // wait 4 seconds for page to settle
      }
    },
  },
  updated() {
    // Over-ride hiding alert
    if (document.querySelector('#uic-ewas-alert-wrapper')) {
      const hideButton = document.querySelector('#uic-ewas-alert-wrapper > div:first-child > div > p:last-child > a');
      hideButton.removeAttribute('onclick');
      hideButton.addEventListener('click', uic_alert_dismissbox_override);

      function uic_alert_dismissbox_override() {
        const uic_emergency_close_settings = new UICEmergencyCloseCookie(document, `message_${UICcookieId}`, 10, null, UICcookieDomain);
        uic_emergency_close_settings.visible = 'false';
        uic_emergency_close_settings.Store();

        const alertWrapper = document.querySelector('.uic-ewas-alert-box');
        const miniWrapper = document.querySelector('.uic-ewas-mini-box');
        alertWrapper.style.cssText = 'display: none !important';
        miniWrapper.style.display = 'block';
      }
    }
  },
};

</script>

<style lang="scss">

.sw-update-bg {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.5;
  background-color: #000;
  z-index: 999999;
}
.sw-update {
  position: fixed;
  bottom: 25%;
  text-align: center;
  left: 0;
  right: 0;
  max-width: 380px;
  margin: 0 auto;
  background-color: $red;
  padding: 20px;
  color: #ffffff;
  z-index: 1000000;
  button {
    margin-left: 5px;
    padding: 10px;
  }
}

</style>
